'use client'

import { useState } from 'react'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cn } from '@utils/cn'

interface NoEmailHelpProps {
  onChangeEmail: () => void
}

export const NoEmailHelp = ({ onChangeEmail }: NoEmailHelpProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div>
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        className="flex w-full items-center justify-center gap-2 text-sm font-medium text-gray-600 dark:text-gray-300"
      >
        Не пришло письмо?
        <FontAwesomeIcon icon={faChevronDown} className={cn('transition-transform', isOpen && 'rotate-180')} />
      </button>

      {isOpen && (
        <ol style={{ fontSize: 13 }} className="mt-3 space-y-2 text-left text-sm text-gray-500 dark:text-gray-400">
          <li>
            1. Проверьте папки «Спам» и «Промоакции». Нашли там письмо — отметьте «Не спам», чтобы следующие приходили
            во «Входящие».
          </li>
          <li>2. Проверьте папку «Спам» и «Промоакции».</li>
          <li>3. Подождите до минуты — письмо может идти с задержкой.</li>
          <li>
            4. Адрес введён с ошибкой?{' '}
            <button type="button" onClick={onChangeEmail} className="link font-semibold">
              Изменить e-mail
            </button>
            .
          </li>
        </ol>
      )}
    </div>
  )
}
